import { CountryInfo, MarketplaceInfo } from 'pages/insights-pro/country-tab/model';
import { MetricsChart } from 'components/MetricsChart';
import { ChartDataArray } from 'components/chart/data/ChartDataArray';
import { ChartDataType } from 'components/chart/data/ChartDataType';
import { ChartData } from 'components/chart/data/ChartData';
import { BarChartRenderer } from 'components/chart/renderer/BarChartRenderer';
import { BarChartConfig } from 'components/chart/data/BarChartConfig';
import { useIntl } from 'react-intl';
import { getArrayWithIsOthers } from 'pages/insights-pro/common/graphs/getArrayWithIsOthers';
import { TileContent } from 'components/Layout/PageContainer';
import { Measure } from 'services/model/model.service';

interface MarketplacesCountrySharesProps {
  countries: CountryInfo[];
  marketplaces: MarketplaceInfo[];
  gmvMeasure: Measure;
}

export function MarketplacesCountryShares({ countries, marketplaces, gmvMeasure }: MarketplacesCountrySharesProps) {
  const intl = useIntl();

  const createMarketplacesChartConfig = () => {
    const marketplacesChartConfig = new BarChartConfig();
    marketplacesChartConfig.breakdownMode = 'fill-stacked';
    marketplacesChartConfig.value = {
      code: gmvMeasure.code,
      label: gmvMeasure.metric.name,
      unit: gmvMeasure.metric.unit,
    };
    marketplacesChartConfig.legendConfig = {
      hide: false,
    };
    const reversedMarketplaces = marketplaces
      .sort((a, b) => b.totalGmv - a.totalGmv)
      .slice(0, 5)
      .reverse();
    marketplacesChartConfig.data = [
      new ChartDataArray(
        ChartDataType.primary,
        'all',
        reversedMarketplaces.map(marketplace => new ChartData(marketplace.name, marketplace.totalGmv))
      ),
      ...getArrayWithIsOthers(countries, [gmvMeasure.code], intl, c => c).map(country => {
        const array = new ChartDataArray(
          ChartDataType.breakdown,
          country.name,
          reversedMarketplaces.map(marketplace => {
            const marketplaceCountry = getArrayWithIsOthers(
              marketplace.countries,
              [gmvMeasure.code],
              intl,
              c => c
            ).find(mc => mc.name === country.name);
            return new ChartData(marketplace.name, gmvMeasure.getValue(marketplaceCountry?.entry.values));
          })
        );
        array.color = country.color;
        return array;
      }),
    ];

    return marketplacesChartConfig;
  };

  const marketplacesChartRenderer = new BarChartRenderer(createMarketplacesChartConfig());

  return (
    <TileContent>
      <MetricsChart renderer={marketplacesChartRenderer} height="h-[400px]" />
    </TileContent>
  );
}
